export default function Hero() {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/81a49bdc39df4d5af0e5696e10b435c7.jpg"
          alt="Premium Supplements Collection"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-emerald-900/60 via-emerald-800/50 to-emerald-900/60"></div>
      </div>
      
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto w-full">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Premium Nutritional Supplements
        </h1>
        <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-2xl mx-auto">
          Power your health with science-backed vitamins, minerals, and wellness supplements
        </p>
        <a href="/personal-care" className="inline-block bg-white text-emerald-700 px-10 py-4 rounded-full text-lg font-semibold hover:bg-emerald-50 transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer">
          Shop Supplements
        </a>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white"></i>
      </div>
    </section>
  );
}
